/**
 * Check if current time is during business hours (weekdays 9-17h CET/CEST)
 * Live indicator is hidden during holidays:
 * - Dec 24-26 (Christmas)
 * - Jan 31 - Feb 2 (New Year/transition period)
 * - Apr 3 & Apr 6, 2026 (Easter - Good Friday & Easter Monday)
 * - May 14, 2026 (Ascension Day)
 */
export const isBusinessHours = (): boolean => {
  const now = new Date();
  const day = now.getDay(); // 0 = Sunday, 1 = Monday, etc.
  const hour = now.getHours();
  const month = now.getMonth(); // 0-11
  const date = now.getDate(); // 1-31
  const year = now.getFullYear();

  // Check if we're in a holiday period where live indicator should be hidden
  // Dec 24-26 (month = 11, date 24-26)
  if (month === 11 && date >= 24 && date <= 26) {
    return false;
  }

  // Jan 31 - Feb 2 (Jan: month = 0, date = 31 OR Feb: month = 1, date = 1-2)
  if ((month === 0 && date === 31) || (month === 1 && date <= 2)) {
    return false;
  }

  // Easter 2026 - Good Friday (Apr 3) & Easter Monday (Apr 6)
  if (year === 2026 && month === 3 && (date === 3 || date === 6)) {
    return false;
  }

  // Ascension Day 2026 (May 14)
  if (year === 2026 && month === 4 && date === 14) {
    return false;
  }

  // Monday to Friday (1-5) and between 9-17h
  return day >= 1 && day <= 5 && hour >= 9 && hour < 17;
};

/**
 * Ahead Health contact phone number
 */
export const CONTACT_PHONE_NUMBER = "+41 44 797 69 46";
export const CONTACT_PHONE_HREF = "tel:+41447976946";
